query EmailCampaignOptions {
  automations(rowsPerPage: 100) {
    nodes {
      id
      name
      kind
    }
  }
}
